// extracted by mini-css-extract-plugin
export default {"root":"BkT1aD2aGBG8gn7N3rg2"};